import React from 'react';
import { createComponent } from '@lit/react';
import { IxCheckbox as LitComp } from '../IxCheckbox.js';

customElements.define('ix-checkbox', LitComp);

export const IxCheckbox = createComponent({
  tagName: 'ix-checkbox-react',
  elementClass: LitComp,
  react: React,
  events: {
    onclick: 'onClick',
  },
});
